import {
  POSTCODE_DISTRICT_BOUNDARIES,
  POSTCODE_SECTOR_BOUNDARIES,
  POSTCODE_UNIT_BOUNDARIES,
  POSTCODE_DISTRICT_BOUNDARIES_ID,
  POSTCODE_SECTOR_BOUNDARIES_ID,
  POSTCODE_UNIT_BOUNDARIES_ID,
} from "../consts/sources";
import { setSourceLoaded } from "../reducers/sources";

import React from "react";
import { Source } from "react-mapbox-gl";
import { useDispatch } from "react-redux";

export const Sources = ({ map }) => {
  const dispatch = useDispatch();

  const onSourceLoaded = (source) => {
    dispatch(setSourceLoaded(source.id));
  };

  return map ? (
    <>
      <Source
        id={POSTCODE_DISTRICT_BOUNDARIES_ID}
        tileJsonSource={POSTCODE_DISTRICT_BOUNDARIES}
        onSourceLoaded={onSourceLoaded}
      />
      <Source
        id={POSTCODE_SECTOR_BOUNDARIES_ID}
        tileJsonSource={POSTCODE_SECTOR_BOUNDARIES}
        onSourceLoaded={onSourceLoaded}
      />
      <Source
        id={POSTCODE_UNIT_BOUNDARIES_ID}
        tileJsonSource={POSTCODE_UNIT_BOUNDARIES}
        onSourceLoaded={onSourceLoaded}
      />
    </>
  ) : null;
};
